import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics/ngx';
import { AlertController, LoadingController, ToastController } from '@ionic/angular/standalone';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { GlobalDataService } from 'src/app/providers/global-data.service';
import { UserCollectionsServices } from 'src/app/providers/user-collection-services';
import { Storage } from '@ionic/storage';
import { AgentsService } from 'src/app/providers/crm-agent-provider';
import { Router } from '@angular/router';
import { SvgPreloadService } from 'src/app/providers/svg-preload.service';
import lottie from 'lottie-web';
import { Browser } from '@capacitor/browser';
import { addIcons } from 'ionicons';
import { close, alertCircleOutline } from 'ionicons/icons';
import {
  NgIf,
  NgFor,
  NgClass,
  DecimalPipe,
  CurrencyPipe,
  CommonModule,
} from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QrCodeModule } from 'ng-qrcode';
import { BtnComponent } from 'src/app/components/btn/btn.component';
import { GetBindersOverlayService } from 'src/app/providers/get-binders-overlay.service';
import { RequestPhysicalCollectionOverlayService } from 'src/app/providers/request-physical-collection-overlay.service';
import { finMethodFromCountry } from 'src/utils/fin-method';

@Component({
  selector: 'app-v2-request-physical-collection',
  templateUrl: './v2-request-physical-collection.component.html',
  styleUrls: ['./v2-request-physical-collection.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgIf,
    FormsModule,
    NgFor,
    NgClass,
    DecimalPipe,
    CurrencyPipe,
    TranslatePipe,
    CommonModule,
    ReactiveFormsModule,
    QrCodeModule,
    BtnComponent,
  ],
})
export class V2RequestPhysicalCollectionComponent implements OnChanges, OnDestroy {
  @Input() isOpen = false;
  @Input() agentId = '';
  @Input() collectionId = '';
  @Input() userCollectionId = '';
  @Input() maxNumAlbumPerUser?: number;
  @Output() closed = new EventEmitter<any>();

  theAgentId: string;
  theCollectionId: string;
  theUserCollectionId: string;

  @ViewChild('overlayRoot', { read: ElementRef }) overlayRootEl?: ElementRef<HTMLDivElement>;
  headerReveal = false;
  contentReveal = false;
  private headerRevealRaf1 = 0;
  private headerRevealRaf2 = 0;
  domOpen = false;
  isClosing = false;
  private closeAnimationFinishTimer: ReturnType<typeof setTimeout> | null = null;
  private static readonly OVERLAY_CLOSE_ANIM_MS = 400;
  /** Cleared on overlay reset; see getAlbum animation poll. */
  private albumLoaderPollInterval: ReturnType<typeof setInterval> | null = null;


  @ViewChild('phoneInput') phoneInput?: ElementRef<HTMLInputElement>;
  @ViewChildren('lottieAvailable') lottieBuyAlbum: QueryList<ElementRef>;
  @ViewChildren('lottiePendingPayment')
  lottiePendingPayment: QueryList<ElementRef>;
  @ViewChildren('lottieWaitingDispatch') WaitingDispatch: QueryList<ElementRef>;
  @ViewChildren('lottieDispatched') Dispatched: QueryList<ElementRef>;
  @ViewChildren('lottieReceived') Received: QueryList<ElementRef>;
  @ViewChildren('lottieWait') Wait: QueryList<ElementRef>;
  @ViewChildren('lottieCancelled') Cancelled: QueryList<ElementRef>;
  @ViewChildren('lottieOnHold') OnHold: QueryList<ElementRef>;
  @ViewChildren('lottieDidntReceive') DidntReceive: QueryList<ElementRef>;
  @ViewChildren('lottieNotAvailable') NotAvailable: QueryList<ElementRef>;
  /** Full-overlay Lottie (same `loaderSvg` as user-collection-manage) while album / physical data loads. */
  @ViewChildren('rpcOverlayLoader') rpcOverlayLoaderContainers: QueryList<ElementRef>;

  focusedIndex: number | null = null;

  code = '';
  qrCodeValue = '';
  counterTotal = 150; // 2.5 minutes
  counterMin = 0;
  counterSec = 0;
  collId = '';
  shippingMethod = '';
  selectedMethod: any = undefined;
  /** Bound to native radio `value`; kept in sync with `selectedMethod`. */
  selectedMethodConfigId: string | number | undefined = undefined;
  fullshippingMethodsList = [];
  shippingMethodsList = [];
  numSpinners = 0;
  operationInProgress = false;
  finMethod = 'NONE';
  currentStatus = '';
  requestFormNumberOfUnits = 1;
  collectionName = '';
  requestPhysColId: string = null;
  requestPartnerId: string = null;
  physCollectionIconPath = '';
  requestFormName = '';
  requestFormAddress1 = '';
  requestFormAddress2 = '';
  requestFormTelephone = '';
  requestFormEmail = '';
  requestFormZipcode = '';
  requestFormLocality = '';
  requestFormCountry = '';
  requestFormNatInternat = '';
  requestFormFinMethod = 'MBWAY';
  requestFormMsisdn = '';
  displayedMsisdn = '';
  requestFormStoreMsisdn = false;
  requestForminvoiceRequired = undefined;
  requestFormNifForInvoice: string = '';
  valCents = 0;
  phyColVCents = 0;
  agent: any = undefined;
  body = document.body;
  validNif = true;
  phyReqId = '';

  isAnimationPlaying: boolean;
  intervalIds: NodeJS.Timeout[] = [];
  animTextNumber: number = 1;
  maxTextNumber: number;
  /** Enables CSS hero-text keyframes only after Lottie’s first frame (or fallback if no asset). */
  loaderTextCssActive = false;
  animTexArr = [
    '',
    'REQUEST_PHYSICAL_COL_HEADER',
    'REQUEST_PHYSICAL_COL_TEXT_1',
    'REQUEST_PHYSICAL_COL_TEXT_2',
  ];
  animTexArr2 = [
    '',
    'PHYS_PENDING_PAYMENT',
    'PHYS_PENDING_PAYMENT_TEXT_1',
    'PHYS_PENDING_PAYMENT_TEXT_2',
  ];
  animTexArr3 = ['', 'PHYS_PENDING_DISPATCH', 'PHYS_PENDING_DISPATCH_TEXT_1'];
  animTexArr4 = ['', 'PHYS_DISPATCHED', 'PHYS_DISPATCHED_TEXT_1'];
  animTexArr5 = [
    '',
    'PHYS_RECEIVED',
    'PHYS_RECEIVED_TEXT_2',
    'PHYS_RECEIVED_TEXT_4',
  ];
  animTexArr6 = ['', 'PHYS_PLEASE_WAIT', 'PHYS_PLEASE_WAIT_TEXT_1', ''];
  animTexArr7 = ['', 'PHYS_CANCELLED_TEXT_1', 'PHYS_CANCELLED_TEXT_2', ''];
  animTexArr8 = [
    '',
    'PHYS_ON_HOLD',
    'PHYS_ON_HOLD_TEXT_1',
    'PHYS_ON_HOLD_TEXT_2',
  ];
  animTexArr9 = [
    '',
    'PHYS_DIDNT_RECEIVE',
    'PHYS_DIDNT_RECEIVE_TEXT_1',
    'PHYS_DIDNT_RECEIVE_TEXT_2',
  ];
  animTexArr10 = [
    '',
    'REQUEST_PHYSICAL_PHYS_COL_NOT_AVAILABLE_TEXT_1',
    'REQUEST_PHYSICAL_PHYS_COL_NOT_AVAILABLE_TEXT_3',
    '',
  ];

  userCollectionDetails: any = undefined;

  /** When true, show full-overlay loader and hide scroll body (same pattern as user-collection-manage). */
  overlayRequestsLoading = false;
  private overlayRequestsLoadingClearTimer: ReturnType<typeof setTimeout> | null = null;
  /** When false, user must complete the collection before ordering the physical album. */
  rpcUserCollectionComplete = true;

  constructor(
    public alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private ga: GoogleAnalytics,
    private gds: GlobalDataService,
    public localStorage: Storage,
    private agentService: AgentsService,
    private router: Router,
    private userColectionsService: UserCollectionsServices,
    public translate: TranslateService,
    private loadingCtrl: LoadingController,
    private _changeDetection: ChangeDetectorRef,
    private svgPreloadService: SvgPreloadService, //private cdr: ChangeDetectorRef
    private getBindersOverlayService: GetBindersOverlayService,
    private requestPhysicalCollectionOverlayService: RequestPhysicalCollectionOverlayService
  ) {
    addIcons({ close, alertCircleOutline });
  }

  /** Opens get-binders overlay and closes this overlay (album order requires a completed collection first). */
  openGetBindersOverlay(): void {
    const agentId = this.theAgentId;
    const collectionId = this.theCollectionId;
    const userCollectionId = this.theUserCollectionId;
    this.requestPhysicalCollectionOverlayService.close();
    setTimeout(() => {
      this.getBindersOverlayService.open({
        agentId,
        collectionId,
        userCollectionId,
        giftInfoOnly: false,
      });
    }, 0);
  }

  /** Loads `percent_complete` via getUserCollectionsStatus (same source as trade-options). */
  private async loadUserCollectionCompletionStatus(): Promise<void> {
    try {
      const res: any = await this.userColectionsService.getUserCollectionsStatus(
        this.theUserCollectionId.toString(),
        this.theAgentId.toString()
      );
      const row = res?.resource?.[0];
      if (row) {
        this.userCollectionDetails = row;
        const pct = Number(row.percent_complete);
        this.rpcUserCollectionComplete = !Number.isNaN(pct) && pct >= 100;
      } else {
        this.rpcUserCollectionComplete = true;
      }
    } catch (e) {
      console.error('loadUserCollectionCompletionStatus', e);
      this.rpcUserCollectionComplete = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']) {
      if (this.isOpen) {
        this.theAgentId = this.agentId;
        this.theCollectionId = this.collectionId;
        this.theUserCollectionId = this.userCollectionId;
        this.clearCloseAnimationFinishTimer();
        const wasClosing = this.isClosing;
        this.isClosing = false;
        this.domOpen = true;
        this.contentReveal = false;
        this.setBodyScrollLock(true);
        if (wasClosing) {
          setTimeout(() => this.resetOverlayEnterAnimationStyles(), 0);
        }
        this.scheduleHeaderRevealAnimation();
        this.scheduleContentReveal();
        void this.onOverlayDataOpen();
      } else {
        this.cancelHeaderRevealAnimation();
        this.headerReveal = false;
        this.contentReveal = false;
        if (this.domOpen) {
          this.isClosing = true;
          this.scheduleCloseAnimationFinish();
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.cancelHeaderRevealAnimation();
    this.clearCloseAnimationFinishTimer();
    this.setBodyScrollLock(false);
    this.resetOverlayComponentState();
  }

  onHeaderBack(): void {
    this.dismissPage({});
  }

  /** Country + fin method (ex-ngOnInit), then album bootstrap — runs each time overlay opens. */
  private async onOverlayDataOpen(): Promise<void> {
    if (!this.theAgentId) {
      return;
    }
    const agentRow = await this.gds.resolveAgentRow();
    if (agentRow) {
      this.requestFormFinMethod = finMethodFromCountry(agentRow.country_cca2);
    }
    console.log('maxNumAlbumPerUser: ', this.maxNumAlbumPerUser);
    if (!this.isOpen) {
      return;
    }
    this.bootstrapPhysicalRequestView();
  }

  private scheduleContentReveal(): void {
    setTimeout(() => {
      if (!this.isOpen) {
        return;
      }
      this.contentReveal = true;
      this._changeDetection.markForCheck();
    }, 50);
  }

  private scheduleHeaderRevealAnimation(): void {
    this.cancelHeaderRevealAnimation();
    this.headerReveal = false;
    this.contentReveal = false;
    this._changeDetection.markForCheck();
    this.headerRevealRaf1 = requestAnimationFrame(() => {
      this.headerRevealRaf1 = 0;
      this.headerRevealRaf2 = requestAnimationFrame(() => {
        this.headerRevealRaf2 = 0;
        this.headerReveal = true;
        this._changeDetection.markForCheck();
      });
    });
  }

  private cancelHeaderRevealAnimation(): void {
    if (this.headerRevealRaf1) {
      cancelAnimationFrame(this.headerRevealRaf1);
      this.headerRevealRaf1 = 0;
    }
    if (this.headerRevealRaf2) {
      cancelAnimationFrame(this.headerRevealRaf2);
      this.headerRevealRaf2 = 0;
    }
  }

  private getOverlayCloseAnimDurationMs(): number {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return V2RequestPhysicalCollectionComponent.OVERLAY_CLOSE_ANIM_MS;
    }
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 0
      : V2RequestPhysicalCollectionComponent.OVERLAY_CLOSE_ANIM_MS;
  }

  private clearCloseAnimationFinishTimer(): void {
    if (this.closeAnimationFinishTimer) {
      clearTimeout(this.closeAnimationFinishTimer);
      this.closeAnimationFinishTimer = null;
    }
  }

  private scheduleCloseAnimationFinish(): void {
    this.clearCloseAnimationFinishTimer();
    const ms = this.getOverlayCloseAnimDurationMs();
    this.closeAnimationFinishTimer = setTimeout(() => {
      this.closeAnimationFinishTimer = null;
      this.isClosing = false;
      this.domOpen = false;
      this.setBodyScrollLock(false);
      this.resetOverlayComponentState();
      this._changeDetection.markForCheck();
    }, ms);
  }

  /** Full reset when the overlay is fully closed so the next open starts clean. */
  private resetOverlayComponentState(): void {
    this.clearAllIntervals();
    if (this.albumLoaderPollInterval != null) {
      clearInterval(this.albumLoaderPollInterval);
      this.albumLoaderPollInterval = null;
    }

    this.clearLottieContainerFlags();

    this.focusedIndex = null;
    this.code = '';
    this.qrCodeValue = '';
    this.counterTotal = 150;
    this.counterMin = 0;
    this.counterSec = 0;
    this.collId = '';
    this.shippingMethod = '';
    this.selectedMethod = undefined;
    this.selectedMethodConfigId = undefined;
    this.fullshippingMethodsList = [];
    this.shippingMethodsList = [];
    this.numSpinners = 0;
    this.operationInProgress = false;
    this.finMethod = 'NONE';
    this.currentStatus = '';
    this.requestFormNumberOfUnits = 1;
    this.collectionName = '';
    this.requestPhysColId = null;
    this.requestPartnerId = null;
    this.physCollectionIconPath = '';
    this.requestFormName = '';
    this.requestFormAddress1 = '';
    this.requestFormAddress2 = '';
    this.requestFormTelephone = '';
    this.requestFormEmail = '';
    this.requestFormZipcode = '';
    this.requestFormLocality = '';
    this.requestFormCountry = '';
    this.requestFormNatInternat = '';
    this.requestFormFinMethod = 'MBWAY';
    this.requestFormMsisdn = '';
    this.displayedMsisdn = '';
    this.requestFormStoreMsisdn = false;
    this.requestForminvoiceRequired = undefined;
    this.requestFormNifForInvoice = '';
    this.valCents = 0;
    this.phyColVCents = 0;
    this.agent = undefined;
    this.validNif = true;
    this.phyReqId = '';
    this.isAnimationPlaying = false;
    this.animTextNumber = 1;
    this.maxTextNumber = undefined;
    this.loaderTextCssActive = false;
    this.userCollectionDetails = undefined;
    this.rpcUserCollectionComplete = true;
    if (this.overlayRequestsLoadingClearTimer) {
      clearTimeout(this.overlayRequestsLoadingClearTimer);
      this.overlayRequestsLoadingClearTimer = null;
    }
    this.overlayRequestsLoading = false;

    this.theAgentId = '';
    this.theCollectionId = '';
    this.theUserCollectionId = '';
  }

  private clearLottieContainerFlags(): void {
    const lists: QueryList<ElementRef>[] = [
      this.rpcOverlayLoaderContainers,
      this.lottieBuyAlbum,
      this.lottiePendingPayment,
      this.WaitingDispatch,
      this.Dispatched,
      this.Received,
      this.Wait,
      this.Cancelled,
      this.OnHold,
      this.DidntReceive,
      this.NotAvailable,
    ];
    for (const q of lists) {
      q?.forEach((ref) => {
        const el = ref.nativeElement as HTMLElement & { _lottieLoaded?: boolean };
        delete el._lottieLoaded;
      });
    }
  }

  private resetOverlayEnterAnimationStyles(): void {
    const el = this.overlayRootEl?.nativeElement;
    if (!el) {
      return;
    }
    el.style.animation = 'none';
    el.style.opacity = '1';
    el.style.transform = 'scale(1)';
    void el.offsetWidth;
    el.style.removeProperty('animation');
    el.style.removeProperty('opacity');
    el.style.removeProperty('transform');
  }

  private setBodyScrollLock(locked: boolean): void {
    if (typeof document === 'undefined') {
      return;
    }
    document.body.classList.toggle('v2-request-phys-col-open', locked);
  }

  /**
   * Loads agent + album status.
   */
  private bootstrapPhysicalRequestView(): void {
    this.overlayRequestsLoading = true;
    this.animTextNumber = 1;
    this.loaderTextCssActive = false;
    this.isAnimationPlaying = false;
    this.loaderRpcOverlayDelayed();
    this.getAgent(0);
    this.getAlbum(0);
  }

  /** Same Lottie asset as `user-collection-manage` (`loaderSvg`). */
  private loaderRpcOverlayDelayed(): void {
    const svgContent = this.svgPreloadService.getSvgContent('loaderSvg');
    if (!svgContent) {
      return;
    }
    setTimeout(() => {
      this.rpcOverlayLoaderContainers?.forEach((container) => {
        const el = container.nativeElement as HTMLElement & { _lottieLoaded?: boolean };
        if (!el._lottieLoaded) {
          lottie.loadAnimation({
            container: el,
            animationData: JSON.parse(svgContent) as object,
            renderer: 'svg',
            loop: true,
            autoplay: true,
          });
          el._lottieLoaded = true;
        }
      });
    }, 50);
  }

  /** Mirrors manage page: brief delay so content stagger matches after data is ready. */
  private endOverlayRequestsLoading(): void {
    if (this.overlayRequestsLoadingClearTimer) {
      clearTimeout(this.overlayRequestsLoadingClearTimer);
      this.overlayRequestsLoadingClearTimer = null;
    }
    if (!this.overlayRequestsLoading) {
      return;
    }
    queueMicrotask(() => {
      requestAnimationFrame(() => {
        this.overlayRequestsLoadingClearTimer = setTimeout(() => {
          this.overlayRequestsLoadingClearTimer = null;
          this.overlayRequestsLoading = false;
          this._changeDetection.markForCheck();
        }, 300);
      });
    });
  }

  animationLoader() {
    this.isAnimationPlaying = false;
    this.loaderTextCssActive = false;
    console.log('Status changed to:', this.currentStatus);
    this.animTextNumber = 1;

    console.log('tu es lindo' + this.currentStatus);

    if (this.currentStatus === 'AVAILABLE') {
      this.maxTextNumber = 3;
      this.loaderBuyAlbumSvgDelayed();
    } else if (this.currentStatus === 'PENDING_PAYMENT') {
      this.maxTextNumber = 3;
      this.loaderPendingPaymentSvgDelayed();
    } else if (this.currentStatus === 'WAITING_DISPATCH') {
      this.maxTextNumber = 2;
      this.loaderWaitingDispatchSvgDelayed();
    } else if (this.currentStatus === 'DISPATCHED') {
      this.maxTextNumber = 2;
      this.loaderDispatchedSvgDelayed();
    } else if (
      this.currentStatus === 'RECEIVED' ||
      this.currentStatus === 'READY'
    ) {
      this.maxTextNumber = 3;
      this.loaderReceivedSvgDelayed();
    } else if (this.currentStatus === 'WAIT') {
      this.maxTextNumber = 2;
      this.loaderWaitSvgDelayed();
    } else if (this.currentStatus === 'CANCELLED') {
      this.maxTextNumber = 2;
      this.loaderCancelledSvgDelayed();
    } else if (this.currentStatus === 'ON_HOLD') {
      this.maxTextNumber = 3;
      this.loaderOnHoldSvgDelayed();
    } else if (this.currentStatus === 'DIDNT_RECEIVE') {
      this.maxTextNumber = 3;
      this.loaderDidntReceiveSvgDelayed();
    } else if (this.currentStatus === 'NOT_AVAILABLE') {
      this.maxTextNumber = 2;
      this.loaderNotAvailableSvgDelayed();
    }
  }

  /** Fires when each CSS keyframe cycle completes (100% = opacity 0); swap copy while invisible. */
  onLoaderTextCycle(event: AnimationEvent): void {
    if (!/loader-text-/.test(event.animationName)) {
      return;
    }
    if (this.animTextNumber === this.maxTextNumber) {
      this.animTextNumber = 1;
    } else {
      this.animTextNumber++;
    }
    this._changeDetection.detectChanges();
  }

  onLoaderTextAnimationStart(event: AnimationEvent): void {
    if (!/loader-text-/.test(event.animationName)) {
      return;
    }
    this.isAnimationPlaying = true;
  }

  onStatusChange(newStatus: string) {
    console.log('Status changed to:', newStatus);
    this.loaderTextCssActive = false;
    this.animTextNumber = 1;

    if (newStatus === 'AVAILABLE') {
      this.maxTextNumber = 3;
      this.loaderBuyAlbumSvgDelayed();
    } else if (newStatus === 'PENDING_PAYMENT') {
      this.maxTextNumber = 3;
      this.loaderPendingPaymentSvgDelayed();
    } else if (newStatus === 'WAITING_DISPATCH') {
      this.maxTextNumber = 2;
      this.loaderWaitingDispatchSvgDelayed();
    } else if (newStatus === 'DISPATCHED') {
      this.maxTextNumber = 2;
      this.loaderDispatchedSvgDelayed();
    } else if (newStatus === 'RECEIVED' || newStatus === 'READY') {
      this.maxTextNumber = 3;
      this.loaderReceivedSvgDelayed();
    } else if (newStatus === 'WAIT') {
      this.maxTextNumber = 2;
      this.loaderWaitSvgDelayed();
    } else if (newStatus === 'CANCELLED') {
      this.maxTextNumber = 2;
      this.loaderCancelledSvgDelayed();
    } else if (newStatus === 'ON_HOLD') {
      this.maxTextNumber = 3;
      this.loaderOnHoldSvgDelayed();
    } else if (newStatus === 'DIDNT_RECEIVE') {
      this.maxTextNumber = 3;
      this.loaderDidntReceiveSvgDelayed();
    } else if (newStatus === 'NOT_AVAILABLE') {
      this.maxTextNumber = 2;
      this.loaderNotAvailableSvgDelayed();
    }

    /*if (this.currentStatus=='AVAILABLE') {
          this.maxTextNumber = 3;
          this.loaderBuyAlbumSvgDelayed();
          // Periodically check if hasVideoLoaded is false
          const checkVideoLoadedInterval = setInterval(() => {
            if (this.currentStatus=='AVAILABLE') {
              // Toggle the text
              if ( this.animTextNumber == this.maxTextNumber) {
                this.animTextNumber = 1;
              }else{
                this.animTextNumber++;
              }
              
              console.log("anim text number" + this.animTextNumber);
            } else {
              // Stop checking once the video has loaded
              clearInterval(checkVideoLoadedInterval);
              console.log("asasdsadsadadasd");
              
            }
        
            // Detect changes to update the view
            this._changeDetection.detectChanges();
          }, 4000); // Check every 4 second to mach animation speed
        }
        if (this.currentStatus=='PENDING_PAYMENT') {
          this.maxTextNumber = 3;
          this.loaderPendingPaymentSvgDelayed();
          // Periodically check if hasVideoLoaded is false
          const checkVideoLoadedInterval = setInterval(() => {
            if (this.currentStatus=='PENDING_PAYMENT') {
              // Toggle the text
              if ( this.animTextNumber == this.maxTextNumber) {
                this.animTextNumber = 1;
              }else{
                this.animTextNumber++;
              }
              
              console.log("anim text number" + this.animTextNumber);
            } else {
              // Stop checking once the video has loaded
              clearInterval(checkVideoLoadedInterval);
              console.log("asasdsadsadadasd");
              
            }
        
            // Detect changes to update the view
            this._changeDetection.detectChanges();
          }, 3400); // Check every 3.50 second to mach animation speed
        }
        if (this.currentStatus=='WAITING_DISPATCH') {
          this.maxTextNumber = 2;
          this.loaderWaitingDispatchSvgDelayed();
          // Periodically check if hasVideoLoaded is false
          const checkVideoLoadedInterval = setInterval(() => {
            if (this.currentStatus=='WAITING_DISPATCH') {
              // Toggle the text
              if ( this.animTextNumber == this.maxTextNumber) {
                this.animTextNumber = 1;
              }else{
                this.animTextNumber++;
              }
              
              console.log("anim text number" + this.animTextNumber);
            } else {
              // Stop checking once the video has loaded
              clearInterval(checkVideoLoadedInterval);
              console.log("asasdsadsadadasd");
              
            }
        
            // Detect changes to update the view
            this._changeDetection.detectChanges();
          }, 4200); // Check every 4.20 second to mach animation speed
        }
        if (this.currentStatus=='DISPATCHED') {
          this.maxTextNumber = 2;
          this.loaderDispatchedSvgDelayed();
          // Periodically check if hasVideoLoaded is false
          const checkVideoLoadedInterval = setInterval(() => {
            if (this.currentStatus=='DISPATCHED') {
              // Toggle the text
              if ( this.animTextNumber == this.maxTextNumber) {
                this.animTextNumber = 1;
              }else{
                this.animTextNumber++;
              }
              
              console.log("anim text number" + this.animTextNumber);
            } else {
              // Stop checking once the video has loaded
              clearInterval(checkVideoLoadedInterval);
              console.log("asasdsadsadadasd");
              
            }
        
            // Detect changes to update the view
            this._changeDetection.detectChanges();
          }, 5150); // Check every 5.15 second to mach animation speed
        }
        if (this.currentStatus=='RECEIVED' || this.currentStatus=='READY') {
          this.maxTextNumber = 3;
          this.loaderReceivedSvgDelayed();
          // Periodically check if hasVideoLoaded is false
          const checkVideoLoadedInterval = setInterval(() => {
            if (this.currentStatus=='RECEIVED' || this.currentStatus=='READY') {
              // Toggle the text
              if ( this.animTextNumber == this.maxTextNumber) {
                this.animTextNumber = 1;
              }else{
                this.animTextNumber++;
              }
              
              console.log("anim text number" + this.animTextNumber);
            } else {
              // Stop checking once the video has loaded
              clearInterval(checkVideoLoadedInterval);
              console.log("asasdsadsadadasd");
              
            }
        
            // Detect changes to update the view
            this._changeDetection.detectChanges();
          }, 3900); // Check every 3.90 second to mach animation speed
        }*/
  }

  // Method to clear all intervals
  clearAllIntervals() {
    this.intervalIds.forEach((intervalId) => clearInterval(intervalId));
    this.intervalIds = []; // Reset the array after clearing intervals
  }

  private markLoaderTextCssReady(): void {
    if (this.loaderTextCssActive) {
      return;
    }
    this.loaderTextCssActive = true;
    this._changeDetection.detectChanges();
  }

  private initLottieInContainer(
    container: ElementRef,
    animationData: object
  ): void {
    const el = container.nativeElement as HTMLElement & {
      _lottieLoaded?: boolean;
    };
    if (el._lottieLoaded) {
      this.markLoaderTextCssReady();
      return;
    }
    const anim = lottie.loadAnimation({
      container: el,
      animationData,
      renderer: 'svg',
      loop: true,
      autoplay: true,
    });
    el._lottieLoaded = true;

    let settled = false;
    let fallbackTimer: ReturnType<typeof setTimeout>;
    const finish = () => {
      if (settled) {
        return;
      }
      settled = true;
      clearTimeout(fallbackTimer);
      anim.removeEventListener('enterFrame', onFirstFrame);
      this.markLoaderTextCssReady();
    };
    const onFirstFrame = () => {
      finish();
    };
    fallbackTimer = setTimeout(() => finish(), 3000);
    anim.addEventListener('enterFrame', onFirstFrame);
  }

  private loadLottieForContainers(
    containers: QueryList<ElementRef>,
    svgCacheKey: string
  ): void {
    const svgContent = this.svgPreloadService.getSvgContent(svgCacheKey);
    if (!svgContent) {
      queueMicrotask(() => this.markLoaderTextCssReady());
      return;
    }
    const data = JSON.parse(svgContent) as object;
    setTimeout(() => {
      this._changeDetection.detectChanges();
      const refs = containers.toArray();
      if (refs.length === 0) {
        setTimeout(() => this.markLoaderTextCssReady(), 400);
        return;
      }
      refs.forEach((container) => this.initLottieInContainer(container, data));
    }, 500);
  }

  loaderBuyAlbumSvgDelayed() {
    this.loadLottieForContainers(this.lottieBuyAlbum, 'buyAlbumSvg');
  }

  loaderPendingPaymentSvgDelayed() {
    this.loadLottieForContainers(this.lottiePendingPayment, 'pendingPaymentSvg');
  }

  loaderWaitingDispatchSvgDelayed() {
    this.loadLottieForContainers(this.WaitingDispatch, 'waitingDispatchSvg');
  }

  loaderDispatchedSvgDelayed() {
    this.loadLottieForContainers(this.Dispatched, 'dispatchedSvg');
  }

  loaderReceivedSvgDelayed() {
    this.loadLottieForContainers(this.Received, 'receivedSvg');
  }

  loaderWaitSvgDelayed() {
    this.loadLottieForContainers(this.Wait, 'waitSvg');
  }

  loaderCancelledSvgDelayed() {
    this.loadLottieForContainers(this.Cancelled, 'CancelledSvg');
  }

  loaderOnHoldSvgDelayed() {
    this.loadLottieForContainers(this.OnHold, 'OnHoldSvg');
  }

  loaderDidntReceiveSvgDelayed() {
    this.loadLottieForContainers(this.DidntReceive, 'DidntReceivedSvg');
  }

  loaderNotAvailableSvgDelayed() {
    this.loadLottieForContainers(this.NotAvailable, 'NotAvailableSvg');
  }

  async getAgent(retries: number) {
    // this.agentService.getCrmAgentById(this.theAgentId.toString()).subscribe({
    //   next: (agent: any) => {
    //     console.log('executed getCrmAgentById. response is:');
    //     this.agent = agent.resource[0];
    //     if (this.agent) {
    //       this.requestFormName =
    //         this.agent.FIRST_NAME + ' ' + this.agent.LAST_NAME;
    //       //PHONE_NO might be null
    //       this.requestFormTelephone = this.agent.PHONE_NO;
    //     }
    //     console.log(this.agent);
    //   },
    //   error: (error) => {
    //     //this.presentAlert('Error getCrmAgentById -> ', error);
    //     if (retries < 3) {
    //       console.error(
    //         'Tentative ' + retries + ' | Calling getAgent() again....'
    //       );
    //       this.gds.getAgentFromStorage().then((agent) => {
    //         console.error('agent from storage - ' + agent);
    //       });

    //       setTimeout(() => {
    //         this.getAgent(retries + 1);
    //       }, 1000);
    //     }
    //   },
    //   complete: () => {
    //     //this.presentAlert('Complete getCrmAgentById .....', 'Ok Done');
    //   },
    // });

    const agentRow = await this.gds.resolveAgentRow();
    if (!this.isOpen) {
      return;
    }
    if (agentRow) {
      this.agent = agentRow;
      this.requestFormName =
        `${agentRow.FIRST_NAME ?? ''} ${agentRow.LAST_NAME ?? ''}`.trim();
      this.requestFormTelephone = agentRow.PHONE_NO;
      console.log(this.agent);
      return;
    }

    if (retries < 3) {
      console.error(
        'Tentative ' + retries + ' | Calling getAgent() again....'
      );
      setTimeout(() => {
        if (!this.isOpen) {
          return;
        }
        this.getAgent(retries + 1);
      }, 1000);
    }
  }

  async getAlbum(retries: number) {
    console.log('aqui ' + this.currentStatus);

    let status = '';

    // this.userColectionsService
    //   .getAlbumByCollectionId(this.theCollectionId.toString())
    //   .subscribe(
    //     (album: any) => {
    //       status = album.resource[0].status;

    //       let hasRuned = false;
    //       const checkIfAnimationIsPlaying = setInterval(() => {
    //         if (this.isAnimationPlaying == true) {
    //           // Stop checking once the video has loaded
    //           clearInterval(checkIfAnimationIsPlaying);
    //         } else if (
    //           (this.currentStatus != '' || this.currentStatus != undefined) &&
    //           this.isAnimationPlaying == false &&
    //           hasRuned == false
    //         ) {
    //           setTimeout(() => {
    //             this.animationLoader();
    //           }, 500);

    //           console.log('123 status: ' + status);
    //           console.log('123 currStatus ' + this.currentStatus);

    //           hasRuned = true;
    //         }
    //         // Detect changes to update the view
    //         this._changeDetection.detectChanges();
    //       }, 200);

    //       if (status === 'NOT_AVAILABLE' || !status) {
    //         // album is not available
    //         this.currentStatus = 'NOT_AVAILABLE';
    //       }

    //       if (status === 'AVAILABLE') {
    //         this.userColectionsService
    //           .getPhysicalColData(
    //             this.theAgentId,
    //             this.theCollectionId,
    //             this.theUserCollectionId
    //           )
    //           .subscribe({
    //             next: async (ret: any) => {
    //               console.log('executed getPhysicalColData. response is:');
    //               const physicalColDataResponse = ret.resource;
    //               console.log(physicalColDataResponse);

    //               // this.userColectionsService
    //               //   .GetCollectionInfoForPhysicalRequest(
    //               //     this.theAgentId,
    //               //     this.theCollectionId,
    //               //     this.theUserCollectionId
    //               //   )
    //               //   .subscribe({
    //               //     next: async (res: any) => {
    //               //       console.log(
    //               //         'executed GetCollectionInfoForPhysicalRequest. response is:'
    //               //       );
    //               //       console.log(res.resource);
    //               //       const collectionResponse = res.resource[0];
    //               //       this.physCollectionIconPath =
    //               //         collectionResponse.collection_icon_path;
    //               //       this.collectionName =
    //               //         collectionResponse.collection_name;

    //               //       if (
    //               //         physicalColDataResponse.pStatus !== null &&
    //               //         physicalColDataResponse.pStatus !== 'CANCELLED'
    //               //       ) {
    //               //         status = physicalColDataResponse.pStatus;

    //               //         if (status === 'ON_HOLD') {
    //               //           this.userColectionsService
    //               //             .getPhysicalRequest(
    //               //               this.theAgentId,
    //               //               this.theCollectionId
    //               //             )
    //               //             .subscribe((ret1: any) => {
    //               //               console.log(ret1.resource);
    //               //               this.requestPhysColId =
    //               //                 ret1.resource[0].phy_col_req_id;
    //               //             });
    //               //         }
    //               //         this.requestPhysColId =
    //               //           physicalColDataResponse.pPhysColReqId;
    //               //         console.log('IMportant: ' + this.requestPhysColId);

    //               //         this.currentStatus = status;
    //               //       } else {
    //               //         if (status === 'CANCELLED') {
    //               //           this.currentStatus = 'AVAILABLE';
    //               //         } else {
    //               //           this.currentStatus = status;
    //               //         }
    //               //         this.phyColVCents =
    //               //           collectionResponse.phy_col_price_cents;
    //               //         //this.userColectionsService
    //               //         //  .getShippingMethodByCollection(this.theCollectionId)
    //               //         //  .subscribe(
    //               //         //    (data: any) => {
    //               //         //      console.log(
    //               //         //        'executed getShippingMethodByCollection. response is:'
    //               //         //      );
    //               //         //      console.log(data.resource);
    //               //         //      this.fullshippingMethodsList = data.resource;
    //               //         //    },
    //               //         //    (err) => {
    //               //         //      console.log(
    //               //         //        'ERROR on getShippingMethodByCollection '
    //               //         //      );
    //               //         //      console.error(err);
    //               //         //    }
    //               //         //  );

    //               //           try {
    //               //             const data: any = await this.userColectionsService
    //               //             .getShippingMethodByCollection(this.theCollectionId);
    //               //             console.log(
    //               //               'executed getShippingMethodByCollection. response is:'
    //               //             );
    //               //             console.log(data.resource);
    //               //             this.fullshippingMethodsList = data.resource;
    //               //           } catch (err) {
    //               //             console.log(
    //               //               'ERROR on getShippingMethodByCollection '
    //               //             );
    //               //             console.error(err);
    //               //           }
    //               //         console.log(this.fullshippingMethodsList);
    //               //       }
    //               //     },
    //               //     error: (err) => {
    //               //       console.log(
    //               //         'ERROR on GetCollectionInfoForPhysicalRequest '
    //               //       );
    //               //       console.error(err);
    //               //       this.dismissPage({});
    //               //     },
    //               //   });

    //               try {
    //                 const res: any = await this.userColectionsService.GetCollectionInfoForPhysicalRequest(this.theAgentId,this.theCollectionId,this.theUserCollectionId);
    //                 console.log(
    //                   'executed GetCollectionInfoForPhysicalRequest. response is:'
    //                 );
    //                 console.log(res.resource);
    //                 const collectionResponse = res.resource[0];
    //                 this.physCollectionIconPath =
    //                   collectionResponse.collection_icon_path;
    //                 this.collectionName =
    //                   collectionResponse.collection_name;

    //                 if (
    //                   physicalColDataResponse.pStatus !== null &&
    //                   physicalColDataResponse.pStatus !== 'CANCELLED'
    //                 ) {
    //                   status = physicalColDataResponse.pStatus;

    //                   if (status === 'ON_HOLD') {
    //                     // this.userColectionsService
    //                     //   .getPhysicalRequest(
    //                     //     this.theAgentId,
    //                     //     this.theCollectionId
    //                     //   )
    //                     //   .subscribe((ret1: any) => {
    //                     //     console.log(ret1.resource);
    //                     //     this.requestPhysColId =
    //                     //       ret1.resource[0].phy_col_req_id;
    //                     //   });

    //                     try {
    //                       const ret1: any = await this.userColectionsService.getPhysicalRequest(this.theAgentId,this.theCollectionId);
    //                       console.log(ret1.resource);
    //                       this.requestPhysColId =
    //                         ret1.resource[0].phy_col_req_id;
    //                     } catch (error) {
    //                       console.log(error);
                          
    //                     }
    //                   }
    //                   this.requestPhysColId =
    //                     physicalColDataResponse.pPhysColReqId;
    //                   console.log('IMportant: ' + this.requestPhysColId);

    //                   this.currentStatus = status;
    //                 } else {
    //                   if (status === 'CANCELLED') {
    //                     this.currentStatus = 'AVAILABLE';
    //                   } else {
    //                     this.currentStatus = status;
    //                   }
    //                   this.phyColVCents =
    //                     collectionResponse.phy_col_price_cents;
    //                   //this.userColectionsService
    //                   //  .getShippingMethodByCollection(this.theCollectionId)
    //                   //  .subscribe(
    //                   //    (data: any) => {
    //                   //      console.log(
    //                   //        'executed getShippingMethodByCollection. response is:'
    //                   //      );
    //                   //      console.log(data.resource);
    //                   //      this.fullshippingMethodsList = data.resource;
    //                   //    },
    //                   //    (err) => {
    //                   //      console.log(
    //                   //        'ERROR on getShippingMethodByCollection '
    //                   //      );
    //                   //      console.error(err);
    //                   //    }
    //                   //  );

    //                     try {
    //                       const data: any = await this.userColectionsService
    //                       .getShippingMethodByCollection(this.theCollectionId);
    //                       console.log(
    //                         'executed getShippingMethodByCollection. response is:'
    //                       );
    //                       console.log(data.resource);
    //                       this.fullshippingMethodsList = data.resource;
    //                     } catch (err) {
    //                       console.log(
    //                         'ERROR on getShippingMethodByCollection '
    //                       );
    //                       console.error(err);
    //                     }
    //                   console.log(this.fullshippingMethodsList);
    //                 }
    //               } catch (err) {
    //                 console.log(
    //                   'ERROR on GetCollectionInfoForPhysicalRequest '
    //                 );
    //                 console.error(err);
    //                 this.dismissPage({});
    //               }
    //             },
    //             error: (err) => {
    //               console.log('ERROR on getPhysicalColData ');
    //               console.error(err);
    //               this.dismissPage({});
    //             },
    //           });
    //       }
    //     },
    //     (error) => {
    //       //this.presentAlert('Error ' + retries + ' - getAlbumByCollectionId -> ', error);
    //       console.error(error);
    //       if (retries < 3) {
    //         console.error(
    //           'Tentative ' + retries + ' | Calling getAlbum() again....'
    //         );

    //         this.gds.getAgentFromStorage().then((agent) => {
    //           console.error('agent from storage - ' + agent);
    //         });

    //         setTimeout(() => {
    //           this.getAlbum(retries + 1);
    //         }, 1000);
    //       }
    //     }
    //   );

    try {
      const album: any = await this.userColectionsService.getAlbumByCollectionId(this.theCollectionId.toString());
      if (!this.isOpen) {
        this.endOverlayRequestsLoading();
        return;
      }
      status = album.resource[0].status;

      console.log('status111: ' + status);
      console.log('currentStatus: ' + this.currentStatus);

          let hasRuned = false;
          if (this.albumLoaderPollInterval != null) {
            clearInterval(this.albumLoaderPollInterval);
            this.albumLoaderPollInterval = null;
          }
          this.albumLoaderPollInterval = setInterval(() => {
            if (!this.isOpen) {
              if (this.albumLoaderPollInterval != null) {
                clearInterval(this.albumLoaderPollInterval);
                this.albumLoaderPollInterval = null;
              }
              return;
            }
            if (this.isAnimationPlaying == true) {
              // Stop checking once the video has loaded
              if (this.albumLoaderPollInterval != null) {
                clearInterval(this.albumLoaderPollInterval);
                this.albumLoaderPollInterval = null;
              }
            } else if (
              (this.currentStatus != '' || this.currentStatus != undefined) &&
              this.isAnimationPlaying == false &&
              hasRuned == false
            ) {
              setTimeout(() => {
                if (this.isOpen) {
                  this.animationLoader();
                }
              }, 500);

              console.log('123 status: ' + status);
              console.log('123 currStatus ' + this.currentStatus);

              hasRuned = true;
            }
            // Detect changes to update the view
            this._changeDetection.detectChanges();
          }, 200);

          if (status === 'NOT_AVAILABLE' || !status) {
            // album is not available
            this.currentStatus = 'NOT_AVAILABLE';
          } else {
            this.currentStatus = status;
          }
          console.log(status)
          console.log(this.currentStatus)
          if (status !== 'AVAILABLE') {
            this.endOverlayRequestsLoading();
          }
          if (status === 'AVAILABLE') {
            await this.loadUserCollectionCompletionStatus();
            if (!this.isOpen) {
              this.endOverlayRequestsLoading();
              return;
            }
            this._changeDetection.detectChanges();
            if (!this.rpcUserCollectionComplete) {
              this.endOverlayRequestsLoading();
              return;
            }
            // this.userColectionsService
            //   .getPhysicalColData(
            //     this.theAgentId,
            //     this.theCollectionId,
            //     this.theUserCollectionId
            //   )
            //   .subscribe({
            //     next: async (ret: any) => {
            //       console.log('executed getPhysicalColData. response is:');
            //       const physicalColDataResponse = ret.resource;
            //       console.log(physicalColDataResponse);

            //       // this.userColectionsService
            //       //   .GetCollectionInfoForPhysicalRequest(
            //       //     this.theAgentId,
            //       //     this.theCollectionId,
            //       //     this.theUserCollectionId
            //       //   )
            //       //   .subscribe({
            //       //     next: async (res: any) => {
            //       //       console.log(
            //       //         'executed GetCollectionInfoForPhysicalRequest. response is:'
            //       //       );
            //       //       console.log(res.resource);
            //       //       const collectionResponse = res.resource[0];
            //       //       this.physCollectionIconPath =
            //       //         collectionResponse.collection_icon_path;
            //       //       this.collectionName =
            //       //         collectionResponse.collection_name;

            //       //       if (
            //       //         physicalColDataResponse.pStatus !== null &&
            //       //         physicalColDataResponse.pStatus !== 'CANCELLED'
            //       //       ) {
            //       //         status = physicalColDataResponse.pStatus;

            //       //         if (status === 'ON_HOLD') {
            //       //           this.userColectionsService
            //       //             .getPhysicalRequest(
            //       //               this.theAgentId,
            //       //               this.theCollectionId
            //       //             )
            //       //             .subscribe((ret1: any) => {
            //       //               console.log(ret1.resource);
            //       //               this.requestPhysColId =
            //       //                 ret1.resource[0].phy_col_req_id;
            //       //             });
            //       //         }
            //       //         this.requestPhysColId =
            //       //           physicalColDataResponse.pPhysColReqId;
            //       //         console.log('IMportant: ' + this.requestPhysColId);

            //       //         this.currentStatus = status;
            //       //       } else {
            //       //         if (status === 'CANCELLED') {
            //       //           this.currentStatus = 'AVAILABLE';
            //       //         } else {
            //       //           this.currentStatus = status;
            //       //         }
            //       //         this.phyColVCents =
            //       //           collectionResponse.phy_col_price_cents;
            //       //         //this.userColectionsService
            //       //         //  .getShippingMethodByCollection(this.theCollectionId)
            //       //         //  .subscribe(
            //       //         //    (data: any) => {
            //       //         //      console.log(
            //       //         //        'executed getShippingMethodByCollection. response is:'
            //       //         //      );
            //       //         //      console.log(data.resource);
            //       //         //      this.fullshippingMethodsList = data.resource;
            //       //         //    },
            //       //         //    (err) => {
            //       //         //      console.log(
            //       //         //        'ERROR on getShippingMethodByCollection '
            //       //         //      );
            //       //         //      console.error(err);
            //       //         //    }
            //       //         //  );

            //       //           try {
            //       //             const data: any = await this.userColectionsService
            //       //             .getShippingMethodByCollection(this.theCollectionId);
            //       //             console.log(
            //       //               'executed getShippingMethodByCollection. response is:'
            //       //             );
            //       //             console.log(data.resource);
            //       //             this.fullshippingMethodsList = data.resource;
            //       //           } catch (err) {
            //       //             console.log(
            //       //               'ERROR on getShippingMethodByCollection '
            //       //             );
            //       //             console.error(err);
            //       //           }
            //       //         console.log(this.fullshippingMethodsList);
            //       //       }
            //       //     },
            //       //     error: (err) => {
            //       //       console.log(
            //       //         'ERROR on GetCollectionInfoForPhysicalRequest '
            //       //       );
            //       //       console.error(err);
            //       //       this.dismissPage({});
            //       //     },
            //       //   });

            //       try {
            //         const res: any = await this.userColectionsService.GetCollectionInfoForPhysicalRequest(this.theAgentId,this.theCollectionId,this.theUserCollectionId);
            //         console.log(
            //           'executed GetCollectionInfoForPhysicalRequest. response is:'
            //         );
            //         console.log(res.resource);
            //         const collectionResponse = res.resource[0];
            //         this.physCollectionIconPath =
            //           collectionResponse.collection_icon_path;
            //         this.collectionName =
            //           collectionResponse.collection_name;

            //         if (
            //           physicalColDataResponse.pStatus !== null &&
            //           physicalColDataResponse.pStatus !== 'CANCELLED'
            //         ) {
            //           status = physicalColDataResponse.pStatus;

            //           if (status === 'ON_HOLD') {
            //             // this.userColectionsService
            //             //   .getPhysicalRequest(
            //             //     this.theAgentId,
            //             //     this.theCollectionId
            //             //   )
            //             //   .subscribe((ret1: any) => {
            //             //     console.log(ret1.resource);
            //             //     this.requestPhysColId =
            //             //       ret1.resource[0].phy_col_req_id;
            //             //   });

            //             try {
            //               const ret1: any = await this.userColectionsService.getPhysicalRequest(this.theAgentId,this.theCollectionId);
            //               console.log(ret1.resource);
            //               this.requestPhysColId =
            //                 ret1.resource[0].phy_col_req_id;
            //             } catch (error) {
            //               console.log(error);
                          
            //             }
            //           }
            //           this.requestPhysColId =
            //             physicalColDataResponse.pPhysColReqId;
            //           console.log('IMportant: ' + this.requestPhysColId);

            //           this.currentStatus = status;
            //         } else {
            //           if (status === 'CANCELLED') {
            //             this.currentStatus = 'AVAILABLE';
            //           } else {
            //             this.currentStatus = status;
            //           }
            //           this.phyColVCents =
            //             collectionResponse.phy_col_price_cents;
            //           //this.userColectionsService
            //           //  .getShippingMethodByCollection(this.theCollectionId)
            //           //  .subscribe(
            //           //    (data: any) => {
            //           //      console.log(
            //           //        'executed getShippingMethodByCollection. response is:'
            //           //      );
            //           //      console.log(data.resource);
            //           //      this.fullshippingMethodsList = data.resource;
            //           //    },
            //           //    (err) => {
            //           //      console.log(
            //           //        'ERROR on getShippingMethodByCollection '
            //           //      );
            //           //      console.error(err);
            //           //    }
            //           //  );

            //             try {
            //               const data: any = await this.userColectionsService
            //               .getShippingMethodByCollection(this.theCollectionId);
            //               console.log(
            //                 'executed getShippingMethodByCollection. response is:'
            //               );
            //               console.log(data.resource);
            //               this.fullshippingMethodsList = data.resource;
            //             } catch (err) {
            //               console.log(
            //                 'ERROR on getShippingMethodByCollection '
            //               );
            //               console.error(err);
            //             }
            //           console.log(this.fullshippingMethodsList);
            //         }
            //       } catch (err) {
            //         console.log(
            //           'ERROR on GetCollectionInfoForPhysicalRequest '
            //         );
            //         console.error(err);
            //         this.dismissPage({});
            //       }
            //     },
            //     error: (err) => {
            //       console.log('ERROR on getPhysicalColData ');
            //       console.error(err);
            //       this.dismissPage({});
            //     },
            //   });

            try {
              const ret: any = await this.userColectionsService.getPhysicalColData(this.theAgentId,this.theCollectionId,this.theUserCollectionId);
              if (!this.isOpen) {
                return;
              }
              console.log('executed getPhysicalColData. response is:');
              const physicalColDataResponse = ret.resource;
              console.log(physicalColDataResponse);

              // this.userColectionsService
              //   .GetCollectionInfoForPhysicalRequest(
              //     this.theAgentId,
              //     this.theCollectionId,
              //     this.theUserCollectionId
              //   )
              //   .subscribe({
              //     next: async (res: any) => {
              //       console.log(
              //         'executed GetCollectionInfoForPhysicalRequest. response is:'
              //       );
              //       console.log(res.resource);
              //       const collectionResponse = res.resource[0];
              //       this.physCollectionIconPath =
              //         collectionResponse.collection_icon_path;
              //       this.collectionName =
              //         collectionResponse.collection_name;

              //       if (
              //         physicalColDataResponse.pStatus !== null &&
              //         physicalColDataResponse.pStatus !== 'CANCELLED'
              //       ) {
              //         status = physicalColDataResponse.pStatus;

              //         if (status === 'ON_HOLD') {
              //           this.userColectionsService
              //             .getPhysicalRequest(
              //               this.theAgentId,
              //               this.theCollectionId
              //             )
              //             .subscribe((ret1: any) => {
              //               console.log(ret1.resource);
              //               this.requestPhysColId =
              //                 ret1.resource[0].phy_col_req_id;
              //             });
              //         }
              //         this.requestPhysColId =
              //           physicalColDataResponse.pPhysColReqId;
              //         console.log('IMportant: ' + this.requestPhysColId);

              //         this.currentStatus = status;
              //       } else {
              //         if (status === 'CANCELLED') {
              //           this.currentStatus = 'AVAILABLE';
              //         } else {
              //           this.currentStatus = status;
              //         }
              //         this.phyColVCents =
              //           collectionResponse.phy_col_price_cents;
              //         //this.userColectionsService
              //         //  .getShippingMethodByCollection(this.theCollectionId)
              //         //  .subscribe(
              //         //    (data: any) => {
              //         //      console.log(
              //         //        'executed getShippingMethodByCollection. response is:'
              //         //      );
              //         //      console.log(data.resource);
              //         //      this.fullshippingMethodsList = data.resource;
              //         //    },
              //         //    (err) => {
              //         //      console.log(
              //         //        'ERROR on getShippingMethodByCollection '
              //         //      );
              //         //      console.error(err);
              //         //    }
              //         //  );

              //           try {
              //             const data: any = await this.userColectionsService
              //             .getShippingMethodByCollection(this.theCollectionId);
              //             console.log(
              //               'executed getShippingMethodByCollection. response is:'
              //             );
              //             console.log(data.resource);
              //             this.fullshippingMethodsList = data.resource;
              //           } catch (err) {
              //             console.log(
              //               'ERROR on getShippingMethodByCollection '
              //             );
              //             console.error(err);
              //           }
              //         console.log(this.fullshippingMethodsList);
              //       }
              //     },
              //     error: (err) => {
              //       console.log(
              //         'ERROR on GetCollectionInfoForPhysicalRequest '
              //       );
              //       console.error(err);
              //       this.dismissPage({});
              //     },
              //   });

              try {
                const res: any = await this.userColectionsService.GetCollectionInfoForPhysicalRequest(this.theAgentId,this.theCollectionId,this.theUserCollectionId);
                if (!this.isOpen) {
                  return;
                }
                console.log('executed GetCollectionInfoForPhysicalRequest. response is: ',res.resource);
                const collectionResponse = res.resource[0];
                this.physCollectionIconPath =
                  collectionResponse.collection_icon_path;
                this.collectionName =
                  collectionResponse.collection_name;
console.log("Physical request status is: " + physicalColDataResponse.pStatus)
                if (
                  physicalColDataResponse.pStatus !== null &&
                  physicalColDataResponse.pStatus !== 'CANCELLED'
                ) {
                  console.log('here')
                  status = physicalColDataResponse.pStatus;

                  if (status === 'ON_HOLD') {
                    // this.userColectionsService
                    //   .getPhysicalRequest(
                    //     this.theAgentId,
                    //     this.theCollectionId
                    //   )
                    //   .subscribe((ret1: any) => {
                    //     console.log(ret1.resource);
                    //     this.requestPhysColId =
                    //       ret1.resource[0].phy_col_req_id;
                    //   });

                    try {
                      const ret1: any = await this.userColectionsService.getPhysicalRequest(this.theAgentId,this.theCollectionId);
                      if (!this.isOpen) {
                        return;
                      }
                      console.log(ret1.resource);
                      this.requestPhysColId =
                        ret1.resource[0].phy_col_req_id;
                    } catch (error) {
                      console.log(error);
                      
                    }
                  }
                  if (!this.isOpen) {
                    return;
                  }
                  this.requestPhysColId =
                    physicalColDataResponse.pPhysColReqId;
                  console.log('IMportant: ' + this.requestPhysColId);

                  this.currentStatus = status;
                } else {
                  console.log('here 2. this.currentStatus:' + this.currentStatus);
                  status = physicalColDataResponse.pStatus;
                  if (status === 'CANCELLED') {
                    this.currentStatus = 'AVAILABLE';
                  } else {
                    this.currentStatus = (status!=null?status:this.currentStatus);
                  }
                  console.log("currentStatus:" + this.currentStatus)
                  this.phyColVCents =
                    collectionResponse.phy_col_price_cents;
                  //this.userColectionsService
                  //  .getShippingMethodByCollection(this.theCollectionId)
                  //  .subscribe(
                  //    (data: any) => {
                  //      console.log(
                  //        'executed getShippingMethodByCollection. response is:'
                  //      );
                  //      console.log(data.resource);
                  //      this.fullshippingMethodsList = data.resource;
                  //    },
                  //    (err) => {
                  //      console.log(
                  //        'ERROR on getShippingMethodByCollection '
                  //      );
                  //      console.error(err);
                  //    }
                  //  );

                    try {
                      const data: any = await this.userColectionsService
                      .getShippingMethodByCollection(this.theCollectionId);
                      if (!this.isOpen) {
                        return;
                      }
                      console.log(
                        'executed getShippingMethodByCollection. response is:'
                      );
                      console.log(data.resource);
                      this.fullshippingMethodsList = data.resource;
                    } catch (err) {
                      console.log(
                        'ERROR on getShippingMethodByCollection '
                      );
                      console.error(err);
                    }
                  console.log(this.fullshippingMethodsList);
                }
              } catch (err) {
                console.log(
                  'ERROR on GetCollectionInfoForPhysicalRequest '
                );
                console.error(err);
                this.dismissPage({});
              }
        } catch (err) {
          console.log('ERROR on getPhysicalColData ');
          console.error(err);
          this.dismissPage({});
        } finally {
          this.endOverlayRequestsLoading();
        }
      }
    } catch (error) {
      //this.presentAlert('Error ' + retries + ' - getAlbumByCollectionId -> ', error);
      console.error(error);
      if (retries < 3) {
        console.error(
          'Tentative ' + retries + ' | Calling getAlbum() again....'
        );

        this.gds.getAgentFromStorage().then((agent) => {
          console.error('agent from storage - ' + agent);
        });

        setTimeout(() => {
          if (!this.isOpen) {
            return;
          }
          this.getAlbum(retries + 1);
        }, 1000);
      } else {
        this.endOverlayRequestsLoading();
      }
    }
  }

  dismissPage(dismissContent: any) {
    this.closed.emit(dismissContent ?? {});
  }

  setFinMethod(val: string) {
    this.requestFormFinMethod = val;
    console.log('Fin Method set to:');
    console.log(this.requestFormFinMethod);
  }

  shippingMethodChange() {
    this.selectedMethod = undefined;
    this.selectedMethodConfigId = undefined;
    this.shippingMethodsList = this.fullshippingMethodsList.filter(
      (item) => item.shipping_method_type === this.shippingMethod
    );
  }

  pickupMethodsExist() {
    const pickupList = this.fullshippingMethodsList.filter(
      (item) => item.shipping_method_type === 'PICKUP'
    );
    return pickupList.length > 0;
  }

  shipmentChanged() {
    this.selectedMethod = undefined;
    this.selectedMethodConfigId = undefined;
    if (this.requestFormNatInternat === 'pt') {
      this.requestFormCountry = 'Portugal';
      this.shippingMethodsList = this.fullshippingMethodsList.filter(
        (item) =>
          item.shipping_method_type === 'SHIPPING' &&
          item.shipping_method_subtype === 'PTG'
      );
    } else {
      this.requestFormCountry = '';
      this.shippingMethodsList = this.fullshippingMethodsList.filter(
        (item) =>
          item.shipping_method_type === 'SHIPPING' &&
          item.shipping_method_subtype === 'INT'
      );
    }
  }

  private applySelectedMethodFromConfigId() {
    const id = this.selectedMethodConfigId;
    this.selectedMethod = this.shippingMethodsList.find(
      (m: any) => String(m.shipping_method_config_id) === String(id)
    );
  }

  onPickupMethodConfigChange(_id: string | number) {
    this.applySelectedMethodFromConfigId();
    this.handlePickUpPointChange(this.selectedMethod);
  }

  onShippingOptionConfigChange(_id: string | number) {
    this.applySelectedMethodFromConfigId();
    this.handleShippingOptionChange(this.selectedMethod);
  }

  validateForm() {
    this.valCents =
      (this.phyColVCents + (this.selectedMethod?.price_cents || 0)) *
      this.requestFormNumberOfUnits;

    if (
      !Number.isInteger(this.requestFormNumberOfUnits) ||
      this.requestFormNumberOfUnits <= 0
    ) {
      return false;
    }

    if (this.shippingMethod !== 'PICKUP' && this.shippingMethod !== 'SHIPPING') {
      return false;
    }

    if (this.shippingMethod === 'PICKUP') {
      if (!this.selectedMethod) {
        return false;
      }
    } else if (this.shippingMethod === 'SHIPPING') {
      if (
        !this.requestFormName ||
        !this.requestFormAddress1 /*|| !this.requestFormAddress2*/ ||
        !this.requestFormCountry ||
        !this.requestFormNatInternat ||
        !this.requestFormLocality ||
        !this.requestFormZipcode
      ) {
        return false;
      }
      if (!this.selectedMethod) {
        return false;
      }
    }

    if (this.valCents > 0) {
      if (
        this.requestFormFinMethod !== 'MBWAY' &&
        this.requestFormFinMethod !== 'VISA'
      ) {
        return false;
      }

      if (this.requestFormFinMethod === 'MBWAY') {
        if (
          !this.requestFormMsisdn ||
          !this.validatePhonePT(this.requestFormMsisdn)
        ) {
          return false;
        }
      }
    }

    if (this.requestForminvoiceRequired && !this.requestFormNifForInvoice) {
      return false;
    }

    if (
      this.requestForminvoiceRequired &&
      !this.validateNIF(this.requestFormNifForInvoice)
    ) {
      return false;
    }

    return true;
  }

  requireInvoice(evt: any) {
    console.log('Requiring invoice');
    console.log(evt);
    console.log(this.requestForminvoiceRequired);
  }

  async submitRequest() {
    console.log('Entering submit Request');
    if (!this.validateForm()) {
      return;
    }

    const request = {
      requestType: 'PHYSICAL_COL',
      requestFormTShipMethodId: this.selectedMethod.shipping_method_config_id,
      requestFormNumberOfUnits: this.requestFormNumberOfUnits,
      requestFormName: this.requestFormName,
      requestFormAddress1: this.requestFormAddress1,
      requestFormAddress2: this.requestFormAddress2,
      requestFormTelephone: this.requestFormTelephone,
      requestFormZipcode: this.requestFormZipcode,
      requestFormLocality: this.requestFormLocality,
      requestFormCountry: this.requestFormCountry,
      requestFormNatInternat: this.requestFormNatInternat,
      requestFormFinMethod: this.requestFormFinMethod,
      requestFormMsisdn: this.requestFormMsisdn, // phone number for MBWAY
      requestFormStoreMsisdn: this.requestFormStoreMsisdn ? 1 : 0,
      requestForminvoiceRequired: this.requestForminvoiceRequired ? 1 : 0,
      requestFormNifForInvoice: this.requestFormNifForInvoice,
      requestFormTotalValue: this.valCents / 100,
    };
    const loading = await this.loadingCtrl.create({
      showBackdrop: true,
      spinner: 'bubbles',
    });
    loading.present();

    // this.userColectionsService
    //   .submitPhysColOrder(
    //     this.theAgentId,
    //     this.theCollectionId,
    //     this.theUserCollectionId,
    //     JSON.stringify(request)
    //   )
    //   .subscribe(
    //     async (resp: any) => {
    //       loading.dismiss();
    //       console.log('request submitted. response was:');
    //       console.log(resp);
    //       if (this.requestFormFinMethod === 'VISA') {
    //         console.log('Launching Payment Page');
    //         const alert = await this.alertCtrl.create({
    //           header: this.translate.instant('VISA_PAYMENT_EXIT'),
    //           message: this.translate.instant('VISA_PAYMENT_EXIT_MSG'),
    //           buttons: [
    //             {
    //               text: this.translate.instant('OK'),
    //               handler: (data) => {
    //                 this.openWithSystemBrowser(resp.finUrl);
    //               },
    //             },
    //           ],
    //         });
    //         await alert.present();
    //       }
    //       if (this.finMethod === 'MBWAY') {
    //         const alert = await this.alertCtrl.create({
    //           header: this.translate.instant('CHECK_MBWAY'),
    //           message: this.translate.instant('CHECK_MBWAY_MSG'),
    //           buttons: [
    //             {
    //               text: this.translate.instant('OK'),
    //               handler: (data) => {},
    //             },
    //           ],
    //         });
    //         await alert.present();
    //       }
    //       const toast = await this.toastCtrl.create({
    //         message: this.translate.instant('SUBMITTED_PHYS_REQUEST'),
    //         duration: 3000,
    //         position: 'bottom',
    //       });
    //       toast.onDidDismiss().then((val) => {
    //         //this.dismissPage({});
    //       });
    //       toast.present();

    //       this.currentStatus = 'PENDING_PAYMENT';
    //       this.animationLoader();
    //     },
    //     (err) => {
    //       console.log(err);
    //       loading.dismiss();
    //       this.presentToast(
    //         this.translate.instant('ERROR_IN_FIN'),
    //         'danger',
    //         'bottom',
    //         2000
    //       );
    //     }
    //   );

    try {
      const resp: any = await this.userColectionsService.submitPhysColOrder(this.theAgentId,this.theCollectionId,this.theUserCollectionId,JSON.stringify(request));
      loading.dismiss();
      console.log('request submitted. response was:');
      console.log(resp);
      if ( resp.success == true ) {
        if (this.requestFormFinMethod === 'VISA') {
          console.log('Launching Payment Page');
          const alert = await this.alertCtrl.create({
            header: this.translate.instant('VISA_PAYMENT_EXIT'),
            message: this.translate.instant('VISA_PAYMENT_EXIT_MSG'),
            buttons: [
              {
                text: this.translate.instant('OK'),
                handler: (data) => {
                  this.openWithSystemBrowser(resp.finUrl);
                },
              },
            ],
          });
          await alert.present();
        }
        if (this.finMethod === 'MBWAY') {
          const alert = await this.alertCtrl.create({
            header: this.translate.instant('CHECK_MBWAY'),
            message: this.translate.instant('CHECK_MBWAY_MSG'),
            buttons: [
              {
                text: this.translate.instant('OK'),
                handler: (data) => {},
              },
            ],
          });
          await alert.present();
        }
        const toast = await this.toastCtrl.create({
          message: this.translate.instant('SUBMITTED_PHYS_REQUEST'),
          duration: 3000,
          position: 'bottom',
        });
        toast.onDidDismiss().then((val) => {
          //this.dismissPage({});
        });
        toast.present();
        console.log("here")
        if (this.valCents == 0)
          if (this.shippingMethod =='PICKUP') {
            this.currentStatus = 'ON_HOLD';
          }
          else {
            this.currentStatus = 'WAITING_DISPACH';
          }
        else {
          this.currentStatus = 'PENDING_PAYMENT';
        }
        this.onStatusChange(this.currentStatus);
        this.animationLoader();

      } else {
        const toast = await this.toastCtrl.create({
          message: this.translate.instant('ERROR_SUBMITTING_PHYS_REQUEST'),
          duration: 3000,
          position: 'bottom',
        });
        toast.onDidDismiss().then((val) => {
          //this.dismissPage({});
        });
        toast.present();

      }
    } catch (err) {
      console.log(err);
          loading.dismiss();
          this.presentToast(
            this.translate.instant('ERROR_IN_FIN'),
            'danger',
            'bottom',
            2000
          );
    }
    //this.goToPreviousPage();
  }

  updateQuantity(evt: any) {
    console.log('entering updateQuantity');
    console.log(evt);
    this.requestFormNumberOfUnits = evt.detail.value;
  }

  public openWithSystemBrowser(url: string) {
    // let target = '_system';
    Browser.open({ url: url });
  }

  goToPreviousPage() {
    this.dismissPage({});
  }

  evalValuesMSISDN(inputEvemt: any) {
    throw new Error('Method not implemented.');
  }

  handlePickUpPointChange(event: any) {
    console.log('Pickup point change detected');
  }

  handleShippingOptionChange(event: any) {
    console.log('Shipping Option change detected');
    console.log(event);
    //this.phyColVCents = event.detail.value.price_cents;
  }

  storeNIFPressed() {
    throw new Error('Method not implemented.');
  }

  storeMsisdnPressed() {
    throw new Error('Method not implemented.');
  }

  notifyWhenColAvailable() {
    console.log('Button Clicked , modal dismissed');
    this.dismissPage({});
  }

  async cancelOrder() {
    // this.userColectionsService
    //   .getPhysicalColData(
    //     this.theAgentId,
    //     this.theCollectionId,
    //     this.theUserCollectionId
    //   )
    //   .subscribe({
    //     next: async (ret: any) => {
    //       const physicalColDataResponse = ret.resource;
    //       this.requestPhysColId = physicalColDataResponse.pPhysColReqId;
    //       // this.userColectionsService
    //       //   .cancelPhyColRequest(
    //       //     this.theAgentId,
    //       //     this.theUserCollectionId,
    //       //     this.theCollectionId,
    //       //     this.requestPhysColId
    //       //   )
    //       //   .subscribe({
    //       //     next: (ret: any) => {
    //       //       console.log('executed cancelPhyColRequest. response is:');
    //       //       console.log(ret.resource);
    //       //       if (ret.resource.p_return_code != 0) {
    //       //         this.presentToast(
    //       //           this.translate.instant('ERROR_CANCEL_ORDER'),
    //       //           'danger',
    //       //           'bottom',
    //       //           2000
    //       //         );
    //       //         return;
    //       //       } else {
    //       //         //this.presentToast(this.translate.instant('ERROR_CANCEL_ORDER'), 'danger', 'bottom', 2000);
    //       //         this.currentStatus = 'CANCELLED';
    //       //         this.animationLoader();
    //       //         return;
    //       //       }
    //       //     },
    //       //     error: (err) => {
    //       //       console.log('ERROR on cancelPhyColRequest ');
    //       //       console.error(err);
    //       //       this.presentToast(
    //       //         this.translate.instant('ERROR_CANCEL_ORDER'),
    //       //         'danger',
    //       //         'bottom',
    //       //         2000
    //       //       );
    //       //       return;
    //       //     },
    //       //   });

    //       try {
    //         const ret: any = await this.userColectionsService.cancelPhyColRequest(this.theAgentId,this.theUserCollectionId,this.theCollectionId,this.requestPhysColId);
    //         console.log('executed cancelPhyColRequest. response is:');
    //             console.log(ret.resource);
    //             if (ret.resource.p_return_code != 0) {
    //               this.presentToast(
    //                 this.translate.instant('ERROR_CANCEL_ORDER'),
    //                 'danger',
    //                 'bottom',
    //                 2000
    //               );
    //               return;
    //             } else {
    //               //this.presentToast(this.translate.instant('ERROR_CANCEL_ORDER'), 'danger', 'bottom', 2000);
    //               this.currentStatus = 'CANCELLED';
    //               this.animationLoader();
    //               return;
    //             }
    //       } catch (err) {
    //         console.log('ERROR on cancelPhyColRequest ');
    //             console.error(err);
    //             this.presentToast(
    //               this.translate.instant('ERROR_CANCEL_ORDER'),
    //               'danger',
    //               'bottom',
    //               2000
    //             );
    //             return;
    //       }
    //     },
    //   });

    try {
      const ret: any = await this.userColectionsService.getPhysicalColData(this.theAgentId,this.theCollectionId,this.theUserCollectionId);
      const physicalColDataResponse = ret.resource;
      this.requestPhysColId = physicalColDataResponse.pPhysColReqId;
      // this.userColectionsService
      //   .cancelPhyColRequest(
      //     this.theAgentId,
      //     this.theUserCollectionId,
      //     this.theCollectionId,
      //     this.requestPhysColId
      //   )
      //   .subscribe({
      //     next: (ret: any) => {
      //       console.log('executed cancelPhyColRequest. response is:');
      //       console.log(ret.resource);
      //       if (ret.resource.p_return_code != 0) {
      //         this.presentToast(
      //           this.translate.instant('ERROR_CANCEL_ORDER'),
      //           'danger',
      //           'bottom',
      //           2000
      //         );
      //         return;
      //       } else {
      //         //this.presentToast(this.translate.instant('ERROR_CANCEL_ORDER'), 'danger', 'bottom', 2000);
      //         this.currentStatus = 'CANCELLED';
      //         this.animationLoader();
      //         return;
      //       }
      //     },
      //     error: (err) => {
      //       console.log('ERROR on cancelPhyColRequest ');
      //       console.error(err);
      //       this.presentToast(
      //         this.translate.instant('ERROR_CANCEL_ORDER'),
      //         'danger',
      //         'bottom',
      //         2000
      //       );
      //       return;
      //     },
      //   });

      try {
        const ret: any = await this.userColectionsService.cancelPhyColRequest(this.theAgentId,this.theUserCollectionId,this.theCollectionId,this.requestPhysColId);
        console.log('executed cancelPhyColRequest. response is:');
            console.log(ret.resource);
            if (ret.resource.p_return_code != 0) {
              this.presentToast(
                this.translate.instant('ERROR_CANCEL_ORDER'),
                'danger',
                'bottom',
                2000
              );
              return;
            } else {
              //this.presentToast(this.translate.instant('ERROR_CANCEL_ORDER'), 'danger', 'bottom', 2000);
              this.currentStatus = 'CANCELLED';
              this.animationLoader();
              return;
            }
      } catch (err) {
        console.log('ERROR on cancelPhyColRequest ');
            console.error(err);
            this.presentToast(
              this.translate.instant('ERROR_CANCEL_ORDER'),
              'danger',
              'bottom',
              2000
            );
            return;
      }
    } catch (error) {
      console.log(error);
    }
  }

  reportRequest() {
    this.alertCtrl
      .create({
        header: this.translate.instant('REPORT_OR_CONTACT_ALERT'),
        message: this.translate.instant('REPORT_OR_CONTACT_ALERT_MSG'),
        buttons: [
          {
            text: this.translate.instant('REPORT_AS_DIDNT_RECEIVED'),
            handler: async () => {
              console.log('Report as didnt received');
              // this.userColectionsService
              //   .updatePhyColRequest(
              //     this.theAgentId,
              //     this.theUserCollectionId,
              //     this.theCollectionId,
              //     this.requestPhysColId,
              //     'DIDNT_RECEIVE'
              //   )
              //   .subscribe({
              //     next: (ret: any) => {
              //       console.log('executed updatePhyColRequest. response is:');
              //       console.log(ret.resource);
              //       if (ret.resource.p_return_code == 0) {
              //         this.currentStatus = 'DIDNT_RECEIVE';
              //         return;
              //       } else {
              //         this.presentToast(
              //           this.translate.instant('DEFAUL_FAIL_MESSAGE'),
              //           'danger',
              //           'bottom',
              //           2000
              //         );
              //         return;
              //       }
              //     },
              //     error: (err) => {
              //       console.log('ERROR on updatePhyColRequest ');
              //       console.error(err);
              //     },
              //   });
              
              try {
                const ret: any = await this.userColectionsService.updatePhyColRequest(this.theAgentId,this.theUserCollectionId,this.theCollectionId,this.requestPhysColId,'DIDNT_RECEIVE');
                console.log('executed updatePhyColRequest. response is:');
                    console.log(ret.resource);
                    if (ret.resource.p_return_code == 0) {
                      this.currentStatus = 'DIDNT_RECEIVE';
                      return;
                    } else {
                      this.presentToast(
                        this.translate.instant('DEFAUL_FAIL_MESSAGE'),
                        'danger',
                        'bottom',
                        2000
                      );
                      return;
                    }
              } catch (err) {
                console.log('ERROR on updatePhyColRequest ');
                    console.error(err);
              }
            },
          },
          {
            text: this.translate.instant('CONTACT_EXME'),
            handler: () => {
              console.log('Email ExME team');
              window.open(`mailto:contact@exme.club`, '_system');
            },
          },
        ],
      })
      .then((alert) => {
        alert.present();
      });
  }

  receivedRequest() {
    this.alertCtrl
      .create({
        header: this.translate.instant('RECEIVED_REQUEST_ALERT'),
        message: this.translate.instant('RECEIVED_REQUEST_ALERT_MSG'),
        buttons: [
          {
            text: this.translate.instant('ACCEPT'),
            handler: async () => {
              console.log('Received Request');
              // this.userColectionsService
              //   .updatePhyColRequest(
              //     this.theAgentId,
              //     this.theUserCollectionId,
              //     this.theCollectionId,
              //     this.requestPhysColId,
              //     'RECEIVED'
              //   )
              //   .subscribe({
              //     next: (ret: any) => {
              //       console.log('executed updatePhyColRequest. response is:');
              //       console.log(ret.resource);
              //       if (ret.resource.p_return_code == 0) {
              //         this.currentStatus = 'RECEIVED';
              //         return;
              //       } else {
              //         this.presentToast(
              //           this.translate.instant('DEFAUL_FAIL_MESSAGE'),
              //           'danger',
              //           'bottom',
              //           2000
              //         );
              //         return;
              //       }
              //     },
              //     error: (err) => {
              //       console.log('ERROR on updatePhyColRequest ');
              //       console.error(err);
              //     },
              //   });

              try {
                const ret: any = await this.userColectionsService.updatePhyColRequest(this.theAgentId,this.theUserCollectionId,this.theCollectionId,this.requestPhysColId,'RECEIVED');
                console.log('executed updatePhyColRequest. response is:');
                console.log(ret.resource);
                if (ret.resource.p_return_code == 0) {
                  this.currentStatus = 'RECEIVED';
                  return;
                } else {
                  this.presentToast(
                    this.translate.instant('DEFAUL_FAIL_MESSAGE'),
                    'danger',
                    'bottom',
                    2000
                  );
                  return;
                }
              } catch (err) {
                console.log('ERROR on updatePhyColRequest ');
                console.error(err);
              }
            },
          },
          {
            text: this.translate.instant('REFUSE'),
            role: 'cancel',
            handler: () => {
              console.log('Refused Request');
            },
          },
        ],
      })
      .then((alert) => {
        alert.present();
      });
  }

  contactRequest() {
    window.open(`mailto:contact@exme.club`, '_system');
  }

  cancelRequest() {
    this.dismissPage({});
  }

  async changeToDispatched() {
    // this.userColectionsService
    //   .updatePhyColRequest(
    //     this.theAgentId,
    //     this.theUserCollectionId,
    //     this.theCollectionId,
    //     this.requestPhysColId,
    //     'DISPATCHED'
    //   )
    //   .subscribe({
    //     next: (ret: any) => {
    //       console.log('executed updatePhyColRequest. response is:');
    //       console.log(ret.resource);
    //       if (ret.resource.p_return_code == 0) {
    //         this.currentStatus = 'DISPATCHED';
    //         return;
    //       } else {
    //         this.presentToast(
    //           this.translate.instant('DEFAUL_FAIL_MESSAGE'),
    //           'danger',
    //           'bottom',
    //           2000
    //         );
    //         return;
    //       }
    //     },
    //     error: (err) => {
    //       console.log('ERROR on updatePhyColRequest ');
    //       console.error(err);
    //     },
    //   });

    try {
      const ret: any = await  this.userColectionsService.updatePhyColRequest( this.theAgentId,this.theUserCollectionId, this.theCollectionId,this.requestPhysColId,'DISPATCHED');
      console.log('executed updatePhyColRequest. response is:');
          console.log(ret.resource);
          if (ret.resource.p_return_code == 0) {
            this.currentStatus = 'DISPATCHED';
            return;
          } else {
            this.presentToast(
              this.translate.instant('DEFAUL_FAIL_MESSAGE'),
              'danger',
              'bottom',
              2000
            );
            return;
          }
    } catch (err) {
      console.log('ERROR on updatePhyColRequest ');
      console.error(err);
    }
  }

  goToAddCol() {
    this.router.navigate(['/add-collection']);
    this.dismissPage({});
  }

  shareOnSocial() {
    throw new Error('Method not implemented.');
  }

  startCountDown() {
    console.log('Entering startCountDown');
    const intervalCounter = setInterval(() => {
      this.counterTotal--;
      this.updateTime();

      if (this.counterTotal === 1) {
        clearInterval(intervalCounter);
        this.resetCounter();
        this.alertCtrl
          .create({
            header: this.translate.instant('TIME_UP_ALERT'),
            message: this.translate.instant('TIME_UP_ALERT_MSG'),
            buttons: [this.translate.instant('OK')],
          })
          .then((alert) => {
            alert.present();
          });
      }
    }, 1000);

    // if validation process starts
    const intervalStatus = setInterval(async () => {
      // this.userColectionsService
      //   .getPhysicalColData(
      //     this.theAgentId,
      //     this.theCollectionId,
      //     this.theUserCollectionId
      //   )
      //   .subscribe(async (ret: any) => {
      //     console.log('executed getPhysicalColData. Return was:');
      //     console.log(ret.resource);
      //     this.collId = this.theCollectionId;
      //     if (ret.resource.pStatus !== 'ON_HOLD') {
      //       clearInterval(intervalCounter);
      //       clearInterval(intervalStatus);
      //       this.resetCounter();
      //       this.currentStatus = ret.resource.pStatus;
      //       console.log('Set Current Status to:' + this.currentStatus);
      //       this.showLoading();
      //     }
      //   });

      try {
        const ret: any = await this.userColectionsService.getPhysicalColData(this.theAgentId,this.theCollectionId,this.theUserCollectionId);
        console.log('executed getPhysicalColData. Return was:');
        console.log(ret.resource);
        this.collId = this.theCollectionId;
        if (ret.resource.pStatus !== 'ON_HOLD') {
          clearInterval(intervalCounter);
          clearInterval(intervalStatus);
          this.resetCounter();
          this.currentStatus = ret.resource.pStatus;
          console.log('Set Current Status to:' + this.currentStatus);
          this.showLoading();
        }
      } catch (error) {
        console.log(error);
      }
    }, 5000);
  }

  resetCounter() {
    this.counterTotal = 150;
    this.code = '';
    this.qrCodeValue = '';
  }

  updateTime() {
    this.counterMin = Math.floor(this.counterTotal / 60);
    this.counterSec = this.counterTotal % 60;
  }

  async generatePickUpCode() {
    console.log('Entering generatePickUpCode');
    // print the arguments
    console.log('Arguments are:');
    console.log(this.requestPhysColId);
    console.log(this.theAgentId);
    console.log(this.theCollectionId);
    console.log(this.requestPartnerId);

    if (
      this.requestPhysColId != null &&
      this.theAgentId != null &&
      this.theCollectionId != null
    ) {
      // this.userColectionsService
      //   .startPickupProcess(
      //     this.requestPhysColId,
      //     this.theAgentId,
      //     this.theCollectionId
      //   )
      //   .subscribe((ret: any) => {
      //     console.log('executed startPickupProcess. response is:');
      //     const response = JSON.parse(ret.resource.pReturnMessage);
      //     this.code = response.code;
      //     this.qrCodeValue = response;
      //     console.log(this.qrCodeValue);
      //     if (this.code !== '' && this.code !== undefined) {
      //       this.startCountDown();
      //     }
      //   });

      try {
        const ret: any = await this.userColectionsService.startPickupProcess(this.requestPhysColId,this.theAgentId,this.theCollectionId);
        console.log('executed startPickupProcess. response is:');
        const response = JSON.parse(ret.resource.pReturnMessage);
        this.code = response.code;
        this.qrCodeValue = response;
        console.log(this.qrCodeValue);
        if (this.code !== '' && this.code !== undefined) {
          this.startCountDown();
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  async showLoading() {
    const loading = await this.loadingCtrl.create({
      message: this.translate.instant('LOADING') + '...',
    });
    await loading.present();

    // Check database status every 2 seconds
    const intervalStatus = setInterval(async () => {
      // this.userColectionsService
      //   .getPhysicalColData(
      //     this.theAgentId,
      //     this.theCollectionId,
      //     this.theUserCollectionId
      //   )
      //   .subscribe(async (ret: any) => {
      //     console.log('executed getPhysicalColData. Return was:');
      //     console.log(ret.resource);

      //     // RECEIVED = success
      //     if (ret.resource.pStatus === 'RECEIVED') {
      //       clearInterval(intervalStatus);
      //       loading.dismiss();
      //       this.currentStatus = ret.resource.pStatus;
      //       this.presentToast(
      //         this.translate.instant('PICKUP_VALIDATION_SUCCESS'),
      //         'success',
      //         'middle',
      //         2000
      //       );
      //     }

      //     // ON_HOLD -> READY -> ON_HOLD = failed validation
      //     if (ret.resource.pStatus === 'ON_HOLD') {
      //       clearInterval(intervalStatus);
      //       loading.dismiss();
      //       this.currentStatus = ret.resource.pStatus;
      //       this.presentToast(
      //         this.translate.instant('PICKUP_VALIDATION_FAILED'),
      //         'danger',
      //         'bottom',
      //         2000
      //       );
      //     }

      //     // 10 sec after READY is timeout
      //     setTimeout(() => {
      //       loading.dismiss();
      //       this.presentToast(
      //         this.translate.instant('PICKUP_VALIDATION_TIMEOUT'),
      //         'danger',
      //         'bottom',
      //         2000
      //       );
      //     }, 10000);
      //   });

      try {
        const ret: any = await this.userColectionsService.getPhysicalColData(this.theAgentId,this.theCollectionId,this.theUserCollectionId);
        console.log('executed getPhysicalColData. Return was:');
        console.log(ret.resource);

        // RECEIVED = success
        if (ret.resource.pStatus === 'RECEIVED') {
          clearInterval(intervalStatus);
          loading.dismiss();
          this.currentStatus = ret.resource.pStatus;
          this.presentToast(
            this.translate.instant('PICKUP_VALIDATION_SUCCESS'),
            'success',
            'middle',
            2000
          );
        }

        // ON_HOLD -> READY -> ON_HOLD = failed validation
        if (ret.resource.pStatus === 'ON_HOLD') {
          clearInterval(intervalStatus);
          loading.dismiss();
          this.currentStatus = ret.resource.pStatus;
          this.presentToast(
            this.translate.instant('PICKUP_VALIDATION_FAILED'),
            'danger',
            'bottom',
            2000
          );
        }

        // 10 sec after READY is timeout
        setTimeout(() => {
          loading.dismiss();
          this.presentToast(
            this.translate.instant('PICKUP_VALIDATION_TIMEOUT'),
            'danger',
            'bottom',
            2000
          );
        }, 10000);
      } catch (error) {
        console.log(error);
      }
    }, 2000);
  }

  async presentToast(
    text: string,
    color: string,
    position: 'top' | 'middle' | 'bottom',
    duration: number
  ) {
    const toast = await this.toastCtrl.create({
      message: text,
      duration,
      position,
      color,
    });
    toast.present();
  }

  appendCountryCode(event: any) {
    const value = event.target!.value;
    const filteredValue = value.replace(/[^0-9]+/g, '');

    this.requestFormMsisdn = filteredValue;
    if (this.phoneInput?.nativeElement) {
      this.phoneInput.nativeElement.value = filteredValue;
    }
  }

  validatePhonePT(phoneNumber: string) {
    const phonePattern = /^9[1236]\d{7}$/;
    return phonePattern.test(phoneNumber);
  }

  validateNIF(nif: string) {
    if (nif.length !== 9) {
      return false;
    }

    const nifDigits: number[] = nif.split('').map(Number);

    const validDigits: number[] = [1, 2, 3, 5, 6, 8];
    if (
      !validDigits.includes(nifDigits[0]) &&
      (nifDigits[0] !== 4 || nifDigits[1] !== 5) &&
      ![7, 9].includes(nifDigits[0])
    ) {
      return false;
    }

    const checkValues: number[] = [9, 8, 7, 6, 5, 4, 3, 2];
    const total: number = nifDigits
      .slice(0, 8)
      .reduce((sum, digit, index) => sum + digit * checkValues[index], 0);

    const division: number = total / 11;
    const mod11: number = total - Math.floor(division) * 11;
    const compare: number = mod11 === 1 || mod11 === 0 ? 0 : 11 - mod11;

    if (nifDigits[8] !== compare) {
      return false;
    }

    return true;
  }

  onNifChange() {
    this.validNif = this.validateNIF(this.requestFormNifForInvoice);
  }

  createRange(start: number, end: number) {
    const range = [];
    for (let i = start; i <= end; i++) {
      range.push(i);
    }
    return range;
  }

  getTotalCollectionPrice() {
    let unitCost=this.phyColVCents;
    unitCost=(unitCost!==undefined && unitCost !== null?unitCost:0);
    const val = (this.phyColVCents * this.requestFormNumberOfUnits) / 100;
    return (val==null?0:val);
  }

  getShippingPrice() {
    let unitCost=this.selectedMethod?.price_cents;
    unitCost=(unitCost!==undefined && unitCost !== null?unitCost:0);
    const val = ( unitCost * this.requestFormNumberOfUnits) / 100;
    return (val==null?0:val);
  }

  getTotalPrice() {
    return this.getTotalCollectionPrice() + this.getShippingPrice();
  }

  async presentAlert(header: string, message: string) {
    const alert = await this.alertCtrl.create({
      header: header,
      message: message,
      buttons: ['OK'],
    });

    await alert.present();
  }

  onQuantityInputBlur() {
    this.clampAlbumQuantity();
  }

  /** Clamps `requestFormNumberOfUnits` to [1, maxNumAlbumPerUser ?? 999]. */
  private clampAlbumQuantity(): void {
    const max = this.maxNumAlbumPerUser ?? 999;
    let n = Math.floor(Number(this.requestFormNumberOfUnits));
    if (!Number.isFinite(n) || n < 1) {
      n = 1;
    }
    if (n > max) {
      n = max;
    }
    this.requestFormNumberOfUnits = n;
  }

  isAlbumQtyDecrementDisabled(): boolean {
    return this.maxNumAlbumPerUser === 1 || this.requestFormNumberOfUnits <= 1;
  }

  isAlbumQtyIncrementDisabled(): boolean {
    const max = this.maxNumAlbumPerUser ?? 999;
    return this.maxNumAlbumPerUser === 1 || this.requestFormNumberOfUnits >= max;
  }

  incrementAlbumQty(): void {
    if (this.maxNumAlbumPerUser === 1) {
      return;
    }
    const max = this.maxNumAlbumPerUser ?? 999;
    if (this.requestFormNumberOfUnits >= max) {
      return;
    }
    this.requestFormNumberOfUnits += 1;
  }

  decrementAlbumQty(): void {
    if (this.maxNumAlbumPerUser === 1) {
      return;
    }
    if (this.requestFormNumberOfUnits <= 1) {
      return;
    }
    this.requestFormNumberOfUnits -= 1;
  }
}
